//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SEO from '~/mixins/SEO.js'
import JSONSCHEMA from '~/mixins/JSONSCHEMA.js'
export default {
    name: 'index',
    mixins: [SEO,JSONSCHEMA],
  data: () => ({
    page: [],
  }),
  asyncData(context) {
    return context.app.$api.fetchSinglePage(context.params.slug)
      .then(response => {
        return {
          page: response.content
        }
      })
      .catch(e =>{
        context.error({ statusCode: 404})
      })
  },
  // async fetch(context) {
  //     try{
  //       const response = await this.$api.fetchSinglePage(context.params.slug)
  //       this.page = response.content
  //     }
      // catch (e){
      //   context.error({ statusCode: 404 })
      // }
  //
  // },
};
